import { style, keyframes } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";

/**
 * Occasional scale pulse animation for the AI icon
 * Stays idle most of the time, then does a quick scale pulse
 */
const scalePulseAnimation = keyframes({
  "0%, 85%, 100%": {
    transform: "scale(1)",
  },
  "90%": {
    transform: "scale(1.15)",
  },
  "95%": {
    transform: "scale(0.95)",
  },
});

/**
 * Inhale glow animation for the gradient box-shadow
 * Contracts deeply inward then expands - more dramatic "breathing" effect
 */
const inhaleGlowAnimation = keyframes({
  "0%, 100%": {
    boxShadow: [
      `0 0 16px 3px ${theme.colors.gradientA}99`,
      `0 0 28px 6px ${theme.colors.gradientB}80`,
      `0 0 40px 10px ${theme.colors.gradientC}66`,
    ].join(", "),
  },
  "50%": {
    boxShadow: [
      `0 0 2px 0px ${theme.colors.gradientA}E6`,
      `0 0 4px 1px ${theme.colors.gradientB}CC`,
      `0 0 8px 2px ${theme.colors.gradientC}B3`,
    ].join(", "),
  },
});

/**
 * Style for the occasional scale pulse effect on the icon
 */
export const scalePulseIconStyle = style({
  animation: `${scalePulseAnimation} 4s ease-in-out infinite`,
});

/**
 * Style for the inhale glow effect on the button wrapper
 */
export const inhaleGlowStyle = style({
  borderRadius: "50%",
  animation: `${inhaleGlowAnimation} 2.5s ease-in-out infinite`,
});
